import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=2b91ce82&scoped=true"
import script from "./Dashboard.ts?vue&type=script&lang=ts&external"
export * from "./Dashboard.ts?vue&type=script&lang=ts&external"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=2b91ce82&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b91ce82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b91ce82')) {
      api.createRecord('2b91ce82', component.options)
    } else {
      api.reload('2b91ce82', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=2b91ce82&scoped=true", function () {
      api.rerender('2b91ce82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Dashboard/pages/Dashboard/Dashboard.vue"
export default component.exports